import React from 'react'
import { Color } from '../../../utils/constants'
import { twMerge } from 'tailwind-merge'

interface MobileMenuButtonProps {
  isOpen: boolean
  setIsOpen: (open: boolean) => void
  color: Color
}

const MobileMenuButton = ({ isOpen, setIsOpen, color }: MobileMenuButtonProps) => {
    const getLineProps = () =>
        twMerge(
            'block absolute h-px w-4 bg-white transition duration-500 ease-in-out',
            color === Color.WHITE ? 'bg-white' : 'bg-black',
        )
    return (
        <button
            className={twMerge(
                'border rounded-full md:hidden p-0 w-12 h-12 relative z-30',
                color === Color.BLACK ? 'border-black' : 'border-white',
            )}
            onClick={() => setIsOpen(!isOpen)}
        >
            <div className='block w-4 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2'>
                <div className={twMerge(getLineProps(), isOpen ? 'rotate-45' : '-translate-y-1')} />
                <div className={twMerge(getLineProps(), isOpen ? '-rotate-45' : 'translate-y-1')} />
            </div>
        </button>
    )
}

export default MobileMenuButton
